export default __webpack_public_path__ + "static/media/success_check_mark.465a6be5.svg";